import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
	{ path: '/', redirect: '/devices' },
	{ path: '/login', name: 'Login', component: () => import('@/views/Login.vue'), meta: { public: true } },
	{ path: '/devices', name: 'DeviceList', component: () => import('@/views/DeviceList.vue') },
	{ path: '/devices/:mac', name: 'DeviceControl', component: () => import('@/views/DeviceControl.vue'), props: true },
	{ path: '/timers', name: 'Timer', component: () => import('@/views/Timer.vue') },
	{ path: '/groups', name: 'Group', component: () => import('@/views/Group.vue') },
	{ path: '/profile', name: 'Profile', component: () => import('@/views/Profile.vue') }
]

const router = new VueRouter({ routes })

// 登录态门禁：没 token 且目标不是公开页（登录页）就拦到登录页
router.beforeEach((to, from, next) => {
	if (!to.meta.public && !store.getters.isLoggedIn) {
		next({ path: '/login', query: { redirect: to.fullPath } })
		return
	}
	if (to.path === '/login' && store.getters.isLoggedIn) {
		next('/devices')
		return
	}
	next()
})

export default router
